<template>
    <div class="board-wrap">
        <!-- 排单管理总台·5 个子tab（阶段16）：待排单(status0·仅创意可见·运营隐藏) / 已排单(status1) / 已定版(status3) / 审批 / 排单动作记录
             ObliqueTags 由各子组件在查询卡下方渲染（查询→tabs→表格，与工单布局一致） -->
        <!-- 阶段16：perm 未确定前不渲染 board，避免运营在 view_perm 回来前误加载待排单(scheduling/pool)触发权限报错 -->
        <!-- 待排单/已排单/已定版 三 tab 共享**单实例** BoardSchedule（方案C·BUG-002-AO 共享查询）：
             v-if=permLoaded 门控首次挂载(避免运营在 view_perm 回来前误加载待排单 scheduling/pool 触发403)；
             v-show=isBoardTab 切到审批/记录只隐藏不销毁 → formData 存活。status/sub-type 按 subTab 动态传，
             切 tab → boardSchedule watch(status) 带 formData 重查。 -->
        <BoardSchedule ref="board" v-if="permLoaded" v-show="isBoardTab" :status="statusOfSubTab" :sub-type="boardSubType" :pageFuncNames="pageFuncNames" :tab-tags="tabTags" :active-tab="subTab" @tab-switch="onTabSwitch2" @view-perm="onViewPerm" @counts-changed="loadCounts"/>
        <ApprovalPanel v-if="subTab==='approval'" :pageFuncNames="approvalFuncNames" :tab-tags="tabTags" active-tab="approval" @tab-switch="onTabSwitch2" @counts-changed="loadCounts"/>
        <BoardLog v-if="subTab==='log'" :tab-tags="tabTags" active-tab="log" @tab-switch="onTabSwitch2"/>
        <!-- 已撤回工单（2026-07-22·排在「排单动作记录」之后）：只读列表，无任何操作。
             shared-params（2026-07-31）：把三 tab 共享的 board 表单状态透传过来，本页**写进自己的 formData**，
             行为与三 tab 互切完全一致——筛选带过去、控件里看得见、能改能清。
             BoardWithdrawn 是 v-if 挂载/销毁，拿到的是**切 tab 那一刻的快照**
             （切过来后 board 已 v-show 隐藏、改不了，快照与实时等价）。 -->
        <BoardWithdrawn ref="boardWithdrawn" v-if="subTab==='withdrawn'" :tab-tags="tabTags" active-tab="withdrawn"
                        :shared-params="sharedParams" @tab-switch="onTabSwitch2" @counts-changed="loadCounts"/>
        <!-- 被驳回（2026-08-31·需求方指定位置：排在「已撤回工单」之后）：只读列表，无任何操作。
             与 BoardWithdrawn 同款 v-if 挂载/销毁 + shared-params 快照继承，行为逐字一致。 -->
        <BoardRejected ref="boardRejected" v-if="subTab==='rejected'" :tab-tags="tabTags" active-tab="rejected"
                       :shared-params="sharedParams" @tab-switch="onTabSwitch2" @counts-changed="loadCounts"/>
    </div>
</template>

<script>
    import BoardSchedule from './boardSchedule.vue';
    import ApprovalPanel from '../approval/index.vue';
    import BoardLog from './boardLog.vue';
    import BoardWithdrawn from './boardWithdrawn.vue';
    import BoardRejected from './boardRejected.vue';
    import scheduleManageAPI from '@/api/workOrder/scheduleManage.js';
    import { mapMutations } from 'vuex';

    export default {
        name: 'ScheduleManagePage',
        components: { BoardSchedule, ApprovalPanel, BoardLog, BoardWithdrawn, BoardRejected },
        props: {
            // 当前 tab(排单管理)的功能节点
            pageFuncNames: { type: Array, default: () => [] },
            // 审批 tab(wos_approval)的功能节点，由 material 透传
            approvalFuncNames: { type: Array, default: () => [] },
        },
        data() {
            return {
                subTab: 'pool',
                // 最近一次的看板 tab（pool/pending/finalized）——切到审批/记录时单实例 BoardSchedule 保持此上下文
                // 不churn（方案C·BUG-002-AO）。默认 pending（运营也可访问·防审批通知落地时回落 pool 触发运营 403）。
                lastBoardTab: 'pending',
                // perm 闸：首次 getList 拿到 view_perm 后才置 true，board 才渲染（避免运营误触待排单接口）
                permLoaded: false,
                // 视图档（schedule_manage/list 返回 view_perm）：demand_side_perm=运营→隐藏待排单 tab
                viewPerm: '',
                counts: { pool: 0, pending: 0, finalized: 0, approval: 0, withdrawn: 0, rejected: 0 },
                // 切到「已撤回」那一刻的 board 查询快照（2026-07-31）→ 透传给 BoardWithdrawn 做补缺继承。
                // 用快照而不是 computed：board.buildQueryParams() 是方法调用，computed 追踪不到它内部的
                // formData 变更，写成 computed 只会得到一个永不刷新的假响应式。
                sharedParams: {},
            };
        },
        computed: {
            // 运营视图（需求方脱敏）→ 隐藏待排单 tab（沿用阶段15 view_perm 判定）
            isOps() { return this.viewPerm === 'demand_side_perm'; },
            // 有任一审批档节点 → 显示「审批 / 排单动作记录」子tab
            hasApproval() { return (this.approvalFuncNames || []).length > 0; },
            // 当前是否看板 tab（三合一 BoardSchedule 显示区）
            isBoardTab() { return ['pool', 'pending', 'finalized'].includes(this.subTab); },
            // 传给单实例 BoardSchedule 的 sub-type：看板 tab=subTab；审批/记录时保持上一个看板 tab（隐藏不 churn）
            boardSubType() { return this.isBoardTab ? this.subTab : this.lastBoardTab; },
            // 对应 scheduling_status
            statusOfSubTab() { return { pool: 0, pending: 1, finalized: 3 }[this.boardSubType]; },
            tabTags() {
                const base = [];
                if (!this.isOps) base.push({ label: '待排单', value: 'pool', num: this.counts.pool });
                base.push({ label: '已排单', value: 'pending', num: this.counts.pending });
                base.push({ label: '已定版', value: 'finalized', num: this.counts.finalized });
                // 审批/记录都是「查看」→ 排单管理用户可见（不绑审批操作权 wos_approval）；
                // 审批的通过/驳回按钮另绑 wos_approval·去操作权后 tab 仍显+列表只读（BUG-002-AT/AQ）
                base.push({ label: '审批', value: 'approval', num: this.counts.approval });
                base.push({ label: '排单动作记录', value: 'log' });
                // 已撤回工单（2026-07-22·需求方指定位置：排在「排单动作记录」之后）
                base.push({ label: '已撤回工单', value: 'withdrawn', num: this.counts.withdrawn });
                // 被驳回（2026-08-31·需求方指定位置：排在「已撤回工单」之后）
                base.push({ label: '被驳回', value: 'rejected', num: this.counts.rejected });
                return base;
            },
        },
        watch: {
            // 权限变化后若当前子tab不可见，回落
            // 审批 tab 现恒显（查看绑访问权·BUG-002-AT），无需再因审批操作权缺失回落
            isOps(v) { if (v && this.subTab === 'pool') this.subTab = 'pending'; },
            // 看板 tab 变化 → 记住，供审批/记录隐藏时 BoardSchedule 保持上下文（方案C）；
            // 从审批/记录返回看板 tab 时 status 可能未变(如 approval→pending)→boardSchedule watch(status) 不触发，
            // 主动 refresh（审批可能已改动排单数据·防陈旧）。看板↔看板由 boardSchedule watch(status) 重查。
            subTab(v, old) {
                const isBoard = t => ['pool', 'pending', 'finalized'].includes(t);
                const wasBoard = isBoard(old);
                const prevBoard = this.lastBoardTab; // 更新前的保持值
                if (isBoard(v)) this.lastBoardTab = v;
                // 仅「从审批/记录返回到隐藏期间保持的同一看板 tab」(status 未变·boardSchedule watch 不触发) 时主动刷新；
                // 返回到不同看板 tab → status 变 → boardSchedule watch(status) 已重查，不重复。
                if (isBoard(v) && !wasBoard && v === prevBoard) {
                    this.$nextTick(() => { if (this.$refs.board && this.$refs.board.refresh) this.$refs.board.refresh(); });
                }
            },
            // 通知跳转兜底（BUG-002-AO）：url query.subTab 到达即 apply（哪怕晚于首次 mount·防落默认 pool）
            '$route.query.subTab'() { this.applyQuerySubTab(); },
        },
        created() {
            // 尽早从 url 落子tab（早于 material 顶层 el-tabs changeTab 可能把 subTab 冲掉的竞态·通知跳转 tab 才对）
            this.applyQuerySubTab();
        },
        mounted() {
            this.applyQuerySubTab();
            this.setCrumb();
            this.loadCounts();
        },
        activated() {
            this.applyQuerySubTab();
            this.setCrumb();
        },
        methods: {
            ...mapMutations('app', ['CHANGE_BREADCRUMB']),
            // 通知跳转：按 url query.subTab 落到对应子tab（待排期超期→pool / 撤回→pending / 审批→approval）。
            // isOps 时 pool 不可见→watch/onViewPerm 自动回落 pending，无需在此判定。
            applyQuerySubTab() {
                const allow = ['pool', 'pending', 'finalized', 'approval', 'log', 'withdrawn', 'rejected'];
                const q = this.$route && this.$route.query ? this.$route.query.subTab : '';
                if (q && allow.indexOf(q) > -1) this.subTab = q;
            },
            setCrumb() {
                const t = (this.tabTags || []).find(x => x.value === this.subTab);
                this.CHANGE_BREADCRUMB(['排单管理', t ? t.label : '待排单']);
            },
            // 子组件首次拿到列表后回吐 view_perm，用于隐藏运营的待排单 tab
            onViewPerm(perm) {
                if (perm && perm !== this.viewPerm) {
                    this.viewPerm = perm;
                    if (this.isOps && this.subTab === 'pool') this.subTab = 'pending';
                }
            },
            onTabSwitch2(val) {
                // 🔴 顺序不能反：BoardWithdrawn 是 v-if 挂载，props 在挂载那一刻取值 →
                //    必须**先**把 board 的查询快照存好，再切 subTab，否则子组件拿到的是上一次的旧快照。
                if (val === 'withdrawn' || val === 'rejected') this.snapshotSharedParams();
                this.subTab = val;
                this.setCrumb();
                this.loadCounts();
            },
            // 快照 board（待排单/已排单/已定版 三 tab 共享实例）的**原始表单状态**。
            // 🔴 传 formData 而不是 buildQueryParams()（2026-07-31 修）：
            //    出参里 delivery_scene/delivery_type 已被拍平成明细 id、日期已拼成 "起/止" 单串，
            //    塞回下拉控件会显示「没选中」。formData 才是控件能直接吃的形态，
            //    两边同名键的类型也基本一致（只有 order_group/is_new 是标量 vs 数组，接收侧归一）。
            snapshotSharedParams() {
                const b = this.$refs.board;
                this.sharedParams = b ? {
                    formData:   { ...b.formData },
                    woFilter:   { ...b.woFilter },
                    projFilter: { ...b.projFilter },
                } : {};
            },
            // 徽标取参：**谁在前台，徽标就跟谁**（2026-07-31）。
            // 已撤回 tab 切入时会把 board 的筛选写进自己的 formData（与三 tab 表现一致），
            // 徽标若还固定吃 board 的参数，两边 WHERE 不同 →
            // 直接复现后端 getTabCounts() 注释里警告的「徽标 51、点进去 54」。
            currentQueryParams() {
                if (this.subTab === 'withdrawn') {
                    const bw = this.$refs.boardWithdrawn;
                    // 拿不到实例（理论上 nextTick 后不会发生）→ 宁可传空走全量口径，
                    // 也不能退回 board 的参数：那是**另一个域**的筛选，数出来的是个谁也对不上的数。
                    return (bw && typeof bw.buildQueryParams === 'function') ? bw.buildQueryParams() : {};
                }
                // 被驳回（2026-08-31）：同已撤回，谁在前台徽标就跟谁，理由见上。
                if (this.subTab === 'rejected') {
                    const br = this.$refs.boardRejected;
                    return (br && typeof br.buildQueryParams === 'function') ? br.buildQueryParams() : {};
                }
                const board = this.$refs.board;
                return (board && typeof board.buildQueryParams === 'function') ? board.buildQueryParams() : {};
            },
            async loadCounts() {
                // 单一轻量接口(tab_counts)：pool/pending/finalized/approval/withdrawn + view_perm，
                // 取代旧的 3 个完整 list 接口数数(慢·重 SELECT)。
                // BUG-002-AV：带上当前查询参数 → 徽标跟随查询结果；无查询时 params 空 → 后端走原全量口径(数量不变)。
                // ⚠️ 必须先等一拍：onTabSwitch2 刚把 subTab 改成 withdrawn/rejected 时，v-if 的
                //    BoardWithdrawn / BoardRejected 还没挂载，$refs 取到的是 undefined。
                await this.$nextTick();
                try {
                    const params = this.currentQueryParams();
                    const r = await scheduleManageAPI.tabCounts(params);
                    const d = (r && r.data) || {};
                    this.counts.pool = d.pool || 0;
                    this.counts.pending = d.pending || 0;
                    this.counts.finalized = d.finalized || 0;
                    this.counts.approval = d.approval || 0;
                    this.counts.withdrawn = d.withdrawn || 0;
                    this.counts.rejected = d.rejected || 0;
                    if (d.view_perm) this.onViewPerm(d.view_perm);
                } catch (e) { /* ignore */ }
                // view_perm 已处理(运营此时 subTab 已落 pending)，放行 board 渲染
                this.permLoaded = true;
            },
        },
    };
</script>

<style scoped lang="scss">
    .board-wrap { padding: 0; }
</style>
